import firebase from 'lib/firebase';
import { upsert, remove } from 'lib/firebase-write';
import omit from 'lodash/omit';

const STORAGE_KEY_DEBTS = 'DEBT_RAINBOW_DEBTS';
const STORAGE_KEY_SETTINGS = 'DEBT_RAINBOW_SETTINGS';

const login = async provider => {
  try {
    const result = await firebase.auth().signInWithPopup(provider);
    return {
      accessToken: result.credential.accessToken,
      user: result.user,
    };
  } catch (e) {
    console.log(e);
  }
};

export const loginFacebook = async () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  provider.addScope('public_profile');
  provider.addScope('email');
  return await login(provider);
};

export const loginGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope('profile');
  provider.addScope('email');
  return await login(provider);
};

export const logout = async () => {
  try {
    await firebase.auth().signOut();
  } catch (e) {
    console.log(e);
  }
};

// Settings
export const updateSettings = async settings => {
  try {
    await upsert(settings, 'settings', 'settingKeys');
  } catch (e) {
    console.log(e);
  }
};

// Debts
export const saveAllDebts = async (debts = []) => {
  try {
    debts.forEach(async toSave => {
      const debt = omit(toSave, ['isNew']);
      await upsert(debt, 'debts', 'debtKeys');
    });
  } catch (e) {
    console.log(e);
  }
};

export const migrateDebts = async (debts = []) => {
  try {
    debts.forEach(async toSave => {
      const debt = omit(toSave, ['id', 'isNew']);
      await upsert(debt, 'debts', 'debtKeys');
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateDebt = async ({ isNew, ...rest }) => {
  try {
    const debt = !!isNew ? omit(rest, ['id']) : rest;
    await upsert(debt, 'debts', 'debtKeys');
    return !!isNew;
  } catch (e) {
    console.log(e);
  }
};

export const removeDebt = async id => {
  try {
    await remove(id, 'debts', 'debtKeys');
  } catch (e) {
    console.log(e);
  }
};

// Local Stuffs
export const fetchLocalDebts = async defaultDebts => {
  const debtGet = localStorage.getItem(STORAGE_KEY_DEBTS);
  return debtGet ? JSON.parse(debtGet) : defaultDebts;
};

export const saveLocalDebts = async debts => {
  const debtSave = JSON.stringify(debts);
  localStorage.setItem(STORAGE_KEY_DEBTS, debtSave);
  return debts;
};

export const fetchLocalSettings = async defaultSettings => {
  const settingsGet = localStorage.getItem(STORAGE_KEY_SETTINGS);
  return settingsGet ? JSON.parse(settingsGet) : defaultSettings;
};

export const saveLocalSettings = async settings => {
  const settingSave = JSON.stringify(settings);
  localStorage.setItem(STORAGE_KEY_SETTINGS, settingSave);
  return settings;
};



// WEBPACK FOOTER //
// ./src/lib/api.js